module.exports = __webpack_public_path__ + "img/mechanicsToolbox.dd044a4f.webp";